import { useCallback } from 'react';
import { generateStudyNotesReport } from 'src/features/report';
import { triggerDownloadFileDialog } from 'src/features/report/report-helpers';
import { DateFormats, localFormat } from 'src/helpers/date-helpers';
import { useStaffProfile, useStudy } from 'src/helpers/hooks/useStudy';
import { normalizeFileName } from 'src/helpers/string-helper';
import { IStudyNoteConfigDto, IStudyNoteResultDto } from 'src/services/api/api-client';

export const useStudyNoteExport = (
  resultsWithConfig:
    | {
        result: IStudyNoteResultDto;
        config: IStudyNoteConfigDto;
      }[]
    | undefined,
) => {
  const study = useStudy();
  const { profile } = useStaffProfile();

  const exportHandler = useCallback(async () => {
    if (!resultsWithConfig?.length || !profile || !study) throw new Error('Not all data provided for report exporting');

    const blob = await generateStudyNotesReport({
      resultsWithConfig: resultsWithConfig,
      studyName: study.title,
      studyNumber: study.studyNumber,
      authorFullName: profile.fullName,
    });

    const fileName = `Study-${study.studyNumber}-${resultsWithConfig[0].config.title}-${localFormat(
      new Date(),
      DateFormats.forFiles,
    )}`;

    triggerDownloadFileDialog(blob, normalizeFileName(fileName));
  }, [profile, resultsWithConfig, study]);

  return {
    exportHandler,
  };
};
